module.exports = __webpack_public_path__ + "img/sand-dune-decal-06.e60de170.png";